var map = {
	"./academia_01.jpg": 26,
	"./academia_02.jpg": 27,
	"./academia_03.jpg": 28,
	"./academia_04.jpg": 29,
	"./academia_05.jpg": 30,
	"./academia_06.jpg": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 296;